import { ParseAdapter } from '../abstract/ParseAdapter';
import { Device } from './device.model';


export interface statusCamera {
    "Id": number,
    "Serial": string,
    "Status": string,
    "Temperature": number
}
export interface dataMonitoring {
    "2DCameras": statusCamera[],
    "3DCameras": statusCamera[],
    "ComDaemon": {
        "Status": string
    },
    "Fan": {
        "Speed": number
    },
    "Motherboard": {
        "Temperature": number
    },
    "Sensors": {
        "Sensor1": {
            "Status": string
        },
        "Sensor2": {
            "Status": string
        }
    },
    "SynchroCard": {
        "Status": string
    }
}

export class MonitorStatus extends ParseAdapter {
    constructor(parseObject: Parse.Object) {
        super(parseObject);
    }


    get devicePtr(): Device { if (this.parseObject.get('devicePtr')) return new Device(this.parseObject.get('devicePtr')) }
    get ipLocal(): String { return this.parseObject.get('ipLocal') || 'N.I.' }
    get masterTemp(): Number { return (this.parseObject.get('masterBoardTemp') ? this.parseObject.get('masterBoardTemp').toFixed(2) : 'N.I.') }
    get slaveTemp(): Number { return (this.parseObject.get('slaveBoardTemp') ? this.parseObject.get('slaveBoardTemp').toFixed(2) : 'N.I.') }
    get workingStatus(): boolean { return this.parseObject.get('status') || 'N.I.' }
    get os(): Number { return this.parseObject.get('osVersion') || 'N.I.' }
    get front(): Number { return this.parseObject.get('frontVersion') || 'N.I.' }
    get back(): Number { return this.parseObject.get('backVersion') || 'N.I.' }
    get ucm(): String { return this.parseObject.get('masterVersion') || 'N.I.' }
    get ucs(): String { return this.parseObject.get('slaveVersion') || 'N.I.' }
    get kittIa(): Number { return this.parseObject.get('kittiaVersion') || 'N.I.' }

    get masterMonitoring(): dataMonitoring { return this.parseObject.get('masterMonitoring') }
    get slaveMonitoring(): dataMonitoring { return this.parseObject.get('slaveMonitoring') }

    critical: string[]
    error: boolean = false;
}

export class EventsLog extends ParseAdapter {
    constructor(parseObject: Parse.Object) {
        super(parseObject);
    }
    get app(): String { return this.parseObject.get('app') || undefined }
    get level(): String { return this.parseObject.get('level') || undefined }
    get message(): String { return this.parseObject.get('message') || undefined }
    get context(): String { return this.parseObject.get('context') || undefined }
    get deviceId(): String { return this.parseObject.get('devicePtr') || undefined }
    deviceName: String;
}


// WEBPACK FOOTER //
// ./src/app/model/monitoring.model.ts